export { default } from './PostalCodeAndCity'
export * from './PostalCodeAndCity'
